var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgUserAvatarBlue = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40.5,
    viewBox: "0 0 40 40.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_39834",
    "data-name": "Group 39834",
    transform: "translate(-281 -564)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Ellipse_1_copy_12",
    "data-name": "Ellipse 1 copy 12",
    d: "M20,0A20,20,0,1,1,0,20,20,20,0,0,1,20,0Z",
    transform: "translate(281 564)",
    fill: "#dbeefe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersection_3",
    "data-name": "Intersection 3",
    d: "M0,27.231a7.919,7.919,0,0,1,1.1-2.4c.827-1.11,4.927-2.621,7.071-3.417.367-.138.681-.254.917-.346a2.315,2.315,0,0,0,.386-.174,16.91,16.91,0,0,0,1.28-1.566h.067V18.18a9.3,9.3,0,0,1-1.493-2.171,7.656,7.656,0,0,1-.4-1.885c-1.291-.588-1.448-2.649-1.5-3.8-.027-.563.242-.613.544-.5A5.176,5.176,0,0,1,7.23,8.325a7.841,7.841,0,0,1-.191-3.343,3.11,3.11,0,0,1,.749-1.858A1.292,1.292,0,0,1,9.6,3.061,2.634,2.634,0,0,1,11.1.641,7.818,7.818,0,0,1,14.055.066c1.8-.113,3.727-.194,5.252.761a5.731,5.731,0,0,1,2.377,5.016,10.92,10.92,0,0,1-.816,3.673c-.01.105-.015.209-.028.318.314-.128.6-.095.577.49-.054,1.156-.21,3.22-1.506,3.805a10.839,10.839,0,0,1-.41,1.882,9.317,9.317,0,0,1-1.48,2.157v1.157h.067a16.761,16.761,0,0,0,1.28,1.566,13.661,13.661,0,0,0,1.285.512c2.14.795,6.26,2.311,7.088,3.424a7.493,7.493,0,0,1,1.023,2.162A20,20,0,0,1,0,27.231Z",
    transform: "translate(286.736 570.787)",
    fill: "#108af9",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgUserAvatarBlue, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/user-avatar-blue.2772b3db.svg";
export { ForwardRef as ReactComponent };